import { DirectiveBinding } from 'vue';

interface ClickOutsideElement extends HTMLElement {
  __clickOutsideHandler__: (event: MouseEvent) => void;
}

const clickOutsideDirective = {
  beforeMount(el: ClickOutsideElement, binding: DirectiveBinding) {
    el.__clickOutsideHandler__ = (event: MouseEvent) => {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value(event);
      }
    };
    document.addEventListener('click', el.__clickOutsideHandler__);
  },
  unmounted(el: ClickOutsideElement) {
    document.removeEventListener('click', el.__clickOutsideHandler__);
  },
};

export default clickOutsideDirective;
